import { ReactNode, createContext, useContext } from "react";
import { PhoneValidationData } from "../pages/home/utils/phoneValidation";
import { useValidatePhone } from "../hooks/usePhoneConfirmation";

type PhoneConfirmationContextType = {
    validatePhone: (phone: PhoneValidationData) => void;
    success: boolean;
    message: string;
    statusCode: number;
}

interface PhoneConfirmationContextProviderProps {
    children: ReactNode
}

const PhoneConfirmationContext = createContext({} as PhoneConfirmationContextType)

export function PhoneConfirmationContextProvider({children}: PhoneConfirmationContextProviderProps) {

    const { validatePhone, message, success,statusCode } = useValidatePhone()

    return (
        <PhoneConfirmationContext.Provider
            value={{
                validatePhone,
                success,
                message,
                statusCode
            }}
        >
            {children}
        </PhoneConfirmationContext.Provider>
    )
}

export function usePhoneConfirmationContext() {
    const phoneValidationContext = useContext(PhoneConfirmationContext)
    return phoneValidationContext
}